import { render, staticRenderFns } from "./rankmatchseasonlist.vue?vue&type=template&id=27096ff3&scoped=true"
import script from "./rankmatchseasonlist.vue?vue&type=script&lang=js"
export * from "./rankmatchseasonlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27096ff3",
  null
  
)

export default component.exports